import { BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.scss';
import { getRoutes } from './Routes';


function App() {
  return (
    <Router>
      <Routes>
       {getRoutes()}
      </Routes>
    </Router>
  );
}

export default App;
